export const actualMeasurements = ({ measurements, actualMeasurementsChoice }) => {
  const actualMeasurements = (measurements || []).find(measurementSet =>
    measurementSet.measurer == actualMeasurementsChoice
  )
  return actualMeasurements || {}
}
